export default "__VITE_ASSET__DrPeAi_U__"